import { StateCreator } from 'zustand'
import { InterJSON, Magazine } from '../../Datatypes'

export interface CurrentMagazineZustandSlice {
    magazine: Magazine | null
    magazineDataForViewer: Array<object>
    interstitialData: InterJSON[] | null
    currentPage: number
    numberOfPages: number

    updateCurrentMagazine: (currentMagazine: Magazine | null) => void
    updateMagazineDataForViewer: (magazineDataForViewer: Array<object>) => void
    updateInterstitialData: (interstitialData: InterJSON[] | null) => void
    updateCurrentPage: (currentPage: number) => void
    updateNumberOfPages: (numberOfPages: number) => void

    _hasHydrated: boolean
    setHasHydrated: (state: any) => void
}

export const createCurrentMagazineZustandSlice: StateCreator<CurrentMagazineZustandSlice> = (set, get) => ({
    magazine: null,
    magazineDataForViewer: [],
    interstitialData: null,
    currentPage: 1,
    numberOfPages: 0,
    
    updateCurrentMagazine: (magazine: Magazine | null) => set(() => ({ magazine: magazine})),
    updateMagazineDataForViewer: (magazineDataForViewer: Array<object>) => set(() => ({ magazineDataForViewer: magazineDataForViewer})),
    updateInterstitialData: (interstitialData: InterJSON[] | null) => set(() => ({interstitialData: interstitialData})),
    updateCurrentPage: (currentPage: number) => set(() => ({ currentPage: currentPage })),
    updateNumberOfPages: (numberOfPages: number) => set(() => ({ numberOfPages: numberOfPages })),

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});

